export default defineNuxtRouteMiddleware(async (to) => {
  // http://example?langcode=fr&customer_id=1234&currencycode=DKK&currencyrate=7.606803&shop=example.myshopify.com&langSuffix=/fr&origin=http://example.com
  const { shop, customer_id, langcode, currencycode, currencyrate, langSuffix, origin } = to.query

  const { fetchLocales } = useStoreStore()
  const { authenticateFromStore } = useStoreAuth()

  const company = await useStoreStore().fetchStoreFromName(shop as string)
  useStoreStore().langCode = langcode as string
  useStoreStore().langSuffix = langSuffix as string
  useStoreStore().origin = origin as string
  useStoreStore().currencyCodeExtension = (currencycode as string) || null
  useStoreStore().currencyRate = !isNaN(parseFloat((currencyrate as string) ?? ''))
    ? parseFloat((currencyrate as string) ?? '')
    : 1.0

  if (company?.company_id) {
    const companyId = company.company_id
    useStoreApp().companyId = companyId
    const customerId = customer_id ? (customer_id as string) : undefined
    await authenticateFromStore(companyId, customerId)
    useStoreCompany().fetchCompany()
    await fetchLocales()
  } else {
    return navigateTo('https://www.loyoly.io', { external: true })
  }
})
